// Router services

import kebabCase from 'lodash/kebabCase'

export const layout = function (path, name, children) {
  const folder = kebabCase(name);

  return {
    path,
    component: () => import(`@/layouts/${folder}/Index`),
    children,
  }
}

export const redirect = function (redirect) {
  return { path: '*', redirect }
}

export const route = function (path, folder, name, file='Index', meta=null, children=null, redirect=null) {
  return {
    path,
    name: !!children ? null : name,
    component: () => import(`@/views/${folder}/${file}.vue`),
    children,
    redirect,
    meta
  }
}

export const subroute = function (path, folder, name, file='Index', meta) {
  return {
    path,
    name,
    component: () => import(`@/views/${folder}/${file}.vue`),
    meta
  }
}

export default {
  layout,
  redirect,
  route,
  subroute
}